<template>
  <div class="trialDetailDetail">
    <el-card>
      <div class="jump-btn">
        <!-- 查看子工单 -->
        <el-button v-if="haveChild == 1" @click="viewChildWorkOrder" type="primary">查看子工单</el-button>
      </div>
      <!-- 报事用户信息 -->
      <el-form
        ref="form"
        :model="form"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-row>
          <!-- 报事用户 -->
          <el-col :span="12">
            <el-form-item :label="$t('lang.lab_backgroundusername')">
              <span v-if="this.form.user != null">{{ this.form.user.nickName|valueIsNull }}</span>
              <span v-else>{{ this.form.username |valueIsNull }}</span>
            </el-form-item>
          </el-col>
          <!-- 联系电话 -->
          <el-col :span="12">
            <el-form-item
              v-if="this.form.user != null"
              :label="$t('lang.lab_backgroundmobile')"
            >{{this.form.user.mobile |valueIsNull}}</el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- 小区 -->
          <el-col :span="12" v-if="this.form.garden">
            <el-form-item :label="$t('lang.lab_backgroundgarden')">
              <span v-if="this.form.garden!= null">{{ this.form.garden.name |valueIsNull }}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <!-- 楼号 -->
          <el-col :span="12" v-if="this.form.garden">
            <el-form-item :label="$t('lang.lab_backgroundhouseName')">
              <span
                v-if="this.form.garden.grids!= null"
              >{{this.form.garden.grids.houseName |valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- 单元号 -->
          <el-col :span="12" v-if="this.form.garden">
            <el-form-item :label="$t('lang.lab_backgroundunitName')">
              <span
                v-if="this.form.garden.grids!= null"
              >{{this.form.garden.grids.unitName |valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <!-- 房间号 -->
          <el-col :span="12" v-if="this.form.garden">
            <el-form-item :label="$t('lang.lab_backgroundroomName')">
              <span
                v-if="this.form.garden.grids!= null"
              >{{this.form.garden.grids.roomName |valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- 报事信息 -->
          <el-col :span="12">
            <!-- <el-form-item
              v-if="this.form.content&&this.form.content.length> require('@/config/enum').tableDatamaxlength"
              :label="$t('lang.lab_backgroundcontent')"
              :title="this.form.content"
            >
              {{ this.form.content.substring(0, require('@/config/enum').tableDatamaxlength) }}
              <span
                v-if="this.form.content.length>require('@/config/enum').tableDatamaxlength"
              >...</span>
            </el-form-item>
            <el-form-item
              v-else
              :label="$t('lang.lab_backgroundcontent')"
            >{{this.form.content |valueIsNull}}</el-form-item> -->
            <el-form-item :label="$t('lang.lab_backgroundcontent')">
              {{this.form.content |valueIsNull}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider></el-divider>
      <!-- 图片 -->
      <el-form
        ref="form"
        :model="form"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-row class="matop">
          <!-- 处理前图片 -->
          <el-col :span="24">
            <el-form-item
              :label="$t('lang.lab_backgroundfilesBefore')"
              v-if="this.form.filesBefore != null"
            >
              <viewer :images="this.form.filesBefore">
                <img
                  v-for="(src,index) in this.form.filesBefore"
                  :src="src.uri"
                  :key="index"
                  class="img"
                />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- 处理后图片 -->
          <el-col :span="24">
            <el-form-item
              :label="$t('lang.lab_backgroundfilesAfter')"
              v-if="this.form.filesAfter != null"
            >
              <viewer :images="this.form.filesAfter">
                <img
                  v-for="(src,index) in this.form.filesAfter"
                  :src="src.uri"
                  :key="index"
                  class="img"
                />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 处理前附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundwithFilesBefore')">
              <a
                class="btnmar"
                :href="src.uri"
                v-for="(src,index) in this.form.withFilesBefore"
                :key="index"
                download
              >{{$t('lang.btn_withfiles')}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 处理后附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundwithFilesAfter')">
              <a
                class="btnmar"
                :href="src.uri"
                v-for="(src,index) in this.form.withFilesAfter"
                :key="index"
                download
              >{{$t('lang.btn_withfiles')}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 跟进回访图片 -->
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$t('lang.lab_backgroundfilesFollow')"
              v-if="this.form.filesFollow != null"
            >
              <viewer :images="this.form.filesFollow">
                <img
                  v-for="(src,index) in this.form.filesFollow"
                  :src="src.uri"
                  :key="index"
                  class="img"
                />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 跟进回访附件 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundwithFilesFollow')">
              <a
                class="btnmar"
                :href="src.uri"
                v-for="(src,index) in this.form.withFilesFollow"
                :key="index"
                download
              >{{$t('lang.btn_withfiles')}}</a>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="matop">
          <el-col :span="8">
            <!-- 报事一级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType1')">
              <span
                v-if="this.form.maintainType1!=null"
              >{{this.form.maintainType1.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 报事二级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType2')">
              <span
                v-if="this.form.maintainType2!=null"
              >{{this.form.maintainType2.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 报事三级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType3' )">
              <span
                v-if="this.form.maintainType3!=null"
              >{{this.form.maintainType3.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <!-- 报事四级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType4')">
              <span
                v-if="this.form.maintainType4!=null"
              >{{this.form.maintainType4.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 报事五级分类 -->
            <el-form-item :label="$t('lang.lab_backgroundmaintainType5')">
              <span
                v-if="this.form.maintainType5!=null"
              >{{this.form.maintainType5.name | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <!-- 工单状态 -->
            <el-form-item :label="$t('lang.lab_backgroundstate')">
              <span>
                <!-- 报事状态 -->
                <span v-if="this.form.state === 0">{{$t('lang.lab_paperereportingstate')}}</span>
                <!-- 待确认 -->
                <span v-if="this.form.state === 1">{{$t('lang.lab_papereconfirmed')}}</span>
                <!-- 处理中 -->
                <span v-if="this.form.state === 2">{{$t('lang.lab_paperesolved')}}</span>
                <!-- 已完成 -->
                <span v-if="this.form.state === 3">{{$t('lang.lab_paperefinsh')}}</span>
                <!-- 已评价 -->
                <span v-if="this.form.state === 4">{{$t('lang.lab_paperealreadyevaluated')}}</span>
                <!-- 正常关闭 -->
                <span v-if="this.form.state === 5">{{$t('lang.lab_paperecloses')}}</span>
                <!-- 非正常关闭 -->
                <span v-if="this.form.state === 6">{{$t('lang.lab_paperenoclose')}}</span>
                <!-- —待处理 -->
                <i v-if="this.form.state === 2" class="normals">{{$t('lang.lab_paperesolveds')}}</i>
                <!-- —待评价 -->
                <i
                  v-if="this.form.state === 3"
                  class="normals"
                >{{$t('lang.lab_paperealreadyevaluateds')}}</i>
                <!-- —已评价 -->
                <i
                  v-if="this.form.state === 4"
                  class="normals"
                >{{$t('lang.lab_alerypaperealreadyevaluateds')}}</i>
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 工单类型 -->
            <el-form-item :label="$t('lang.lab_backgroundnormal')">
              <!-- 正常工单 -->
              <span v-if="this.form.normal === 0">{{$t('lang.lab_normalLift')}}</span>
              <!-- 延时工单 -->
              <span v-if="this.form.normal === 1">{{$t('lang.lab_outlLift')}}</span>
              <!-- 正常工单 -->
              <span v-if="this.form.normal === 2">{{$t('lang.lab_normalLift')}}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-divider></el-divider>
      <el-form
        ref="form"
        :model="form"
        class="form"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-row class="matop">
          <el-col :span="8">
            <!-- 接单人员 -->
            <el-form-item :label="$t('lang.lab_backgroundstaffId')">
              <span
                v-if="this.form.staffId != 0&&this.form.staff!= null"
              >{{this.form.staff.idNo | valueIsNull}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 处理人员 -->
            <el-form-item
              :label="$t('lang.lab_backgroundcheckerName')"
            >{{this.form.checkerName | valueIsNull}}</el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <!-- 评价等级 选择评价 评价内容 图片评价 -->
        <!-- 评价等级 -->
        <el-row v-if="form.evaluateDetailList&&form.evaluateDetailList.length>0">
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_rating')">
              <!-- 好评 -->
              <span
                v-if="this.form.evaluateDetailList[0].oneEvaluation===1"
              >{{$t('lang.lab_praise')}}</span>
              <!-- 中评 -->
              <span
                v-if="this.form.evaluateDetailList[0].oneEvaluation===2"
              >{{$t('lang.lab_average')}}</span>
              <!-- 差评 -->
              <span v-if="this.form.evaluateDetailList[0].oneEvaluation===3">{{$t('lang.lab_bad')}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 选择评价 -->
        <el-row v-if="form.evaluateDetailList&&form.evaluateDetailList.length>0">
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundtwoEvaluation')">
              <span
                v-if="this.form.evaluateDetailList[0].twoEvaluation"
              >{{this.form.evaluateDetailList[0].twoEvaluation}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 评价内容 -->
        <el-row v-if="form.evaluateDetailList&&form.evaluateDetailList.length>0">
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgroundthreeEvaluation')">
              <span
                v-if="this.form.evaluateDetailList[0].threeEvaluation"
              >{{this.form.evaluateDetailList[0].threeEvaluation}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 图片评价 -->
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('lang.lab_backgrounduri')">
              <viewer :images="this.form.filesEvaluate">
                <img
                  v-for="(src,index) in this.form.filesEvaluate"
                  :src="src.uri"
                  :key="index"
                  class="img"
                />
              </viewer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row class="matop">
          <el-col :span="8">
            <!-- 审阅状态 -->
            <el-form-item :label="$t('lang.lab_backgroundisCheck')">
              <!-- 未审阅 -->
              <span v-if="this.form.isCheck === 0">{{$t('lang.lab_notreviewed')}}</span>
              <!-- 合格 -->
              <span v-else-if="this.form.isCheck === 1">{{$t('lang.lab_qualified')}}</span>
              <!-- 不合格 -->
              <span v-else-if="this.form.isCheck === 2">{{$t('lang.lab_noqualified')}}</span>
              <span v-else>---</span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 审阅图片 -->
            <el-form-item :label="$t('lang.lab_backgroundfilesCheck')">
              <viewer :images="this.form.filesCheck">
                <img
                  v-for="(src,index) in this.form.filesCheck"
                  :src="src.uri"
                  :key="index"
                  class="img"
                />
              </viewer>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 审阅备注 -->
            <el-form-item
              v-if="this.form.checkInfo&&this.form.checkInfo.length> require('@/config/enum').tableDatamaxlength"
              :label="$t('lang.lab_backgroundcheckInfo')"
              :title="this.form.checkInfo"
            >
              {{ this.form.checkInfo.substring(0, require('@/config/enum').tableDatamaxlength) }}
              <span
                v-if="this.form.checkInfo.length>require('@/config/enum').tableDatamaxlength"
              >...</span>
            </el-form-item>
            <el-form-item
              v-else
              :label="$t('lang.lab_backgroundcheckInfo')"
            >{{this.form.checkInfo |valueIsNull}}</el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <!-- 工单一生 -->
        <el-form-item :label="$t('lang.lab_backgroundleft')">
          <el-table :data="tableData" class="wid80" :row-class-name="tableRowClassName">
            <el-table-column prop="createtime" :label="$t('lang.lab_backgroundtime')">
              <template slot-scope="scope">{{ scope.row.createtime | time }}</template>
            </el-table-column>
            <el-table-column prop="action" :label="$t('lang.lab_backgroundnat')"></el-table-column>
            <el-table-column :label="$t('lang.lab_backgroundtext')" width="850px">
              <template slot-scope="scope">
                <!-- <el-tooltip
                  placement="top"
                  effect="light"
                  v-if="scope.row.content2&&scope.row.content2.length> require('@/config/enum').tableDatamaxlength"
                  :disabled="false"
                >
                  <div slot="content">
                    <span>{{scope.row.content1}}：{{ scope.row.content2.replace('null', "") }}</span>
                  </div>
                  <div>
                    <font color="#c69c6d">
                      {{scope.row.content1}}：
                      <strong>{{scope.row.content2.replace('null', "").substring(0, require('@/config/enum').tableDatamaxlength) | valueIsNull}}</strong>
                    </font>
                    <span
                      v-if="scope.row.content2.length>require('@/config/enum').tableDatamaxlength"
                    >...</span>
                  </div>
                </el-tooltip>
                <el-tooltip placement="top" effect="light" v-else :disabled="true"> -->
                  <div>
                    <font color="#c69c6d">
                      {{scope.row.content1}}：
                      <strong>{{scope.row.content2.replace('null', "")}}</strong>
                    </font>
                  </div>
                <!-- </el-tooltip> -->
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <!-- 巡检路线 -->
      <el-form
        v-if="showPL"
        :model="formpl"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-form-item :label="$t('lang.lab_route')">
          <el-button
            @click="updatePatrolPointLineId(maintainPatrolPointLine[0].patrolPointLine)"
            v-if="this.maintainPatrolPointLine.length>0"
          >{{maintainPatrolPointLine[0].patrolPointLineName}}</el-button>
          &emsp;{{$t('lang.lab_notreviewed')}}{{this.jindu}}
        </el-form-item>
        <el-form-item :label="$t('lang.lab_PL')">
          <el-table
            :data="maintainPatrolPointLine"
            class="wid80"
            :row-class-name="tableRowClassName"
          >
            <el-table-column prop="createtime" :label="$t('lang.lab_PL_time')">
              <template slot-scope="scope">{{ scope.row.createTime | time }}</template>
            </el-table-column>
            <el-table-column prop="pointName" :label="$t('lang.lab_PL_pointName')">
              <template slot-scope="scope">
                <el-button @click="updatePatrolPointId(scope.row)">{{scope.row.pointName}}</el-button>
              </template>
            </el-table-column>
            <el-table-column :label="$t('lang.lab_PL_state')">
              <template slot-scope="scope">
                <span v-if="scope.row.state===0">{{$t('lang.lab_nofinish')}} ：{{scope.row.info}}</span>
                <span
                  v-else-if="scope.row.state===1"
                >{{$t('lang.lab_aleryfinish')}} ：{{scope.row.info}}</span>
                <span v-else>{{$t('lang.lab_unfinishs')}} ：{{scope.row.info}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-divider></el-divider>
      </el-form>
      <!-- 巡检标准进度 列表-->
      <el-form
        v-if="show"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-form-item :label="$t('lang.lab_Patrol')">
          <span>{{$t('lang.lab_allStateCount')}}:{{maintainPatrol[0].allStateCount}}</span>
          <span
            class="pad-lef20"
          >{{$t('lang.lab_finishStateCount')}}:{{maintainPatrol[0].finishStateCount}}</span>
          <span
            class="pad-lef20"
          >{{$t('lang.lab_errorStateCount')}}:{{maintainPatrol[0].errorStateCount}}</span>
          <span
            class="pad-lef20"
          >{{$t('lang.lab_missStateCount')}}:{{maintainPatrol[0].missStateCount}}</span>
          <span
            class="pad-lef20"
          >{{$t('lang.lab_undoneStateCount')}}:{{maintainPatrol[0].undoneStateCount}}</span>
        </el-form-item>
        <el-form-item label>
          <el-table :data="maintainPatrol" class="wid80" :row-class-name="tableRowClassName">
            <!-- 小区 -->
            <el-table-column
              v-if="showpages!='fourhundred'"
              prop="gardenName"
              :label="$t('lang.lab_village')"
            >
              <template slot-scope="scope">{{scope.row.gardenName | valueIsNull}}</template>
            </el-table-column>
            <!-- 楼号 -->
            <el-table-column
              v-if="showpages!='fourhundred'"
              prop="houseName"
              :label="$t('lang.lab_buildingnum')"
            >
              <template slot-scope="scope">{{scope.row.houseName | valueIsNull}}</template>
            </el-table-column>
            <!-- 单元 -->
            <el-table-column
              v-if="showpages!='fourhundred'"
              prop="unitName"
              :label="$t('lang.lab_isUnitId')"
            >
              <template slot-scope="scope">{{scope.row.unitName | valueIsNull}}</template>
            </el-table-column>
            <!-- 房间 -->
            <el-table-column
              v-if="showpages!='fourhundred'"
              prop="roomName"
              :label="$t('lang.lab_isRoomId')"
            >
              <template slot-scope="scope">{{scope.row.roomName | valueIsNull}}</template>
            </el-table-column>
            <!-- 时间 -->
            <el-table-column prop="createTime" :label="$t('lang.lab_backgroundtime')" width="180">
              <template slot-scope="scope">{{ scope.row.createTime | time }}</template>
            </el-table-column>
            <!-- 巡检标准 -->
            <el-table-column prop="patrolStandardName" :label="$t('lang.lab_inspectionStandard')">
              <template slot-scope="scope">
                <el-button
                  @click="patrol(scope.row.patrolStandard)"
                >{{ scope.row.patrolStandardName }}</el-button>
              </template>
            </el-table-column>
            <!-- 完成情况 -->
            <el-table-column :label="$t('lang.lab_finishstatue')" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.state===0">{{$t('lang.lab_nofinish')}} ：{{scope.row.info}}</span>
                <span
                  v-else-if="scope.row.state===1"
                >{{$t('lang.lab_aleryfinish')}} ：{{scope.row.info}}</span>
                <span v-else-if="scope.row.state===3">{{$t('lang.lab_misss')}} ：{{scope.row.info}}</span>
                <span v-else>{{$t('lang.lab_unfinishs')}} ：{{scope.row.info}}</span>
              </template>
            </el-table-column>
            <!-- 图片详情 -->
            <el-table-column :label="$t('lang.lab_photodetail')" width="240">
              <template slot-scope="scope">
                <viewer :images="scope.row.urls">
                  <img v-for="(src,index) in scope.row.urls" :src="src" :key="index" class="img" />
                </viewer>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="input"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :page-count="pageCount"
          />
        </el-form-item>
        <el-divider></el-divider>
      </el-form>
      <!-- 巡检设备完成进度 -->
      <el-form
        ref="form"
        :model="form"
        v-if="showDevice"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-form-item :label="$t('lang.lab_Device')">
          <div v-for="(md,index) in maintainDevice" :key="index">
            <p>
              {{md.createTime|time}}&emsp;
              <button type="button">{{md.deviceName}}</button>
              &emsp;
              <span v-if="md.state===0">{{$t('lang.lab_nofinish')}} ：{{md.info}}</span>
              <span v-else-if="md.state===1">{{$t('lang.lab_aleryfinish')}} ：{{md.info}}</span>
              <span v-else>{{$t('lang.lab_unfinishs')}} ：{{md.info}}</span>
            </p>
            <viewer :images="md.urls">
              <img v-for="(src,index) in md.urls" :src="src" :key="index" class="img" />
            </viewer>
          </div>
        </el-form-item>
        <el-divider></el-divider>
      </el-form>
      <!-- 处理抽审 form.evaluate === 1&&取消 -->
      <div v-if="isDispatch === 1" class="sampling">{{$t('lang.lab_sampling')}}</div>
      <el-form
        ref="formcs"
        :rules="rulecs"
        :model="formcs"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <!-- <el-form-item :label="$t('lang.lab_trialOrderresults')" prop="maintainTypeId1">
          <el-select v-model="hege" :disabled="rimdetails.hege!=1">
            <el-option
              v-for="(item,index) in trialOrderresultslist"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('lang.lab_trialOrderresults')" prop="maintainTypeId1">
          <el-radio v-model="hege" :disabled="rimdetails.hege!=1" v-for="(item,index) in trialOrderresultslist" v-if="index!=0" :key="index" :label="item.id" :value="item.id">{{item.name}}</el-radio>
        </el-form-item>
        <el-form-item v-if="hege === 3" label="不合格条线" prop="randomMaintainType1">
          <el-select v-model="formcs.randomMaintainType1" :disabled="rimdetails.hege!=1" placeholder="请选择不合格条线">
            <el-option 
              v-for="(item, index) in firstLevellist" 
              :key="index" 
              :label="item.name" 
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 处理意见 -->
        <el-form-item :label="$t('lang.lab_resolution')" prop="content">
          <el-input
            class="input"
            :disabled="rimdetails.hege!=1"
            maxlength="100"
            type="textarea"
            v-model="formcs.content"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_resolution')"
          ></el-input>
        </el-form-item>
        <!-- 建议 -->
        <el-form-item :label="$t('lang.lab_propose')" prop="suggest">
          <el-input
            class="input"
            :disabled="rimdetails.hege!=1"
            maxlength="100"
            type="textarea"
            v-model="formcs.suggest"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_propose')"
          ></el-input>
        </el-form-item>
        <!-- 抽审工单图片 -->
        <el-form-item
          :label="$t('lang.lab_trialOrderuploadPhotograph')"
          v-if="rimdetails.rimFiles&&rimdetails.rimFiles.length>0"
        >
          <viewer :images="rimdetails.rimFiles">
            <img v-for="(src,index) in rimdetails.rimFiles" :src="src.uri" :key="index" class="img" />
          </viewer>
        </el-form-item>
        <!-- 上传图片  -->
        <el-form-item
          :label="$t('lang.lab_uploadPhotograph')"
          prop="files1"
          v-if="rimdetails.hege === 1"
        >
          <upload-morefile ref="uploading" :accept='accept'  upTypes='1'  :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-morefile> 
        </el-form-item>
        <!-- 处理完成 -->
        <el-button
          v-if="rimdetails.hege === 1"
          class="btn-first"
          type="primary"
          @click="updateRandomInspection()"
        >{{$t('lang.btn_finish')}}</el-button>
      </el-form>
      <!-- 抽审处理中工单 -->
      <el-form
        v-if="this.form.state === 2 && !showToDo && !showToDoDevice"
        ref="formcs"
        :rules="rulecs"
        :model="formcs"
        class="matop"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <!-- 处理人员  -->
        <el-form-item :label="$t('lang.lab_Handler')" prop="peopleid">
          <el-select
            v-model="formcs.peopleid"
            :placeholder="$t('lang.lab_please_Select')+$t('lang.lab_Handler')"
          >
            <el-option
              v-for="(item,index) in peoplelist"
              :key="index"
              :label="item.idNo"
              :value="item.idNo+','+item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('lang.lab_backgroundInfo')">
          <el-input
            class="input"
            type="textarea"
            maxlength="200"
            v-model="formcs.contents"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_backgroundInfo')"
          ></el-input>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files">
          <upload-morefile ref="uploading" :accept='accept'  upTypes='1'  :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-morefile> 
        </el-form-item>
        <!-- 上传附件 -->
        <el-form-item :label="$t('lang.lab_accessories')" prop="files1">
          <upload-morefile ref="uploading"  upTypes='0'  :clears='clears' @outputFile="getFilefj" @removeFile='removeFilefj'></upload-morefile>
        </el-form-item>
        <el-button
          class="btn-first"
          type="primary"
          @click="finish('formcs')"
        >{{$t('lang.btn_finish')}}</el-button>
        <!-- <el-button class="detailbtn" type="primary" @click="print()">{{$t('lang.btn_print')}}</el-button> -->
      </el-form>
      <!-- 巡检设备备注上传图片 -->
      <el-form
        :rules="rulesbs"
        v-if="this.form.state === 2 && showToDoDevice"
        ref="formsbs"
        :model="formsbs"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <!-- 巡检设备 -->
        <el-form-item :label="$t('lang.lab_Devices')" prop="maintainDeviceToDos">
          <el-select v-model="formsbs.maintainDeviceToDos">
            <el-option key :label="$t('lang.lab_please_Select')+$t('lang.lab_Devices')" value></el-option>
            <el-option
              v-for="(item,index) in maintainDeviceToDo"
              :key="index"
              :label="item.deviceName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('lang.lab_remark')">
          <el-input class="input" type="textarea" v-model="formsbs.infodevs"></el-input>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files">
          <upload-morefile ref="uploading" :accept='accept'  upTypes='1'  :clears='clears' @outputFile="getFilesb" @removeFile='removeFilesb'></upload-morefile>
        </el-form-item>
        <!-- 完成, 异常 -->
        <el-button
          class="btn-first"
          type="primary"
          @click="finishdevide('formsbs')"
        >{{$t('lang.btn_finishs')}}</el-button>
        <el-button
          class="btn_orange detailbtn"
          @click="unfinishdevide('formsbs')"
        >{{$t('lang.btn_unfinishs')}}</el-button>
        <el-divider></el-divider>
      </el-form>
      <!-- 巡检标准 -->
      <el-form
        class="matop"
        :rules="rulebzs"
        v-if="this.form.state === 2 && showToDo"
        ref="formbzs"
        :model="formbzs"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-form-item :label="$t('lang.lab_inspectionStandard')" prop="maintainPatrolToDos">
          <el-select v-model="formbzs.maintainPatrolToDos">
            <el-option
              key
              :label="$t('lang.lab_please_Select')+$t('lang.lab_inspectionStandard')"
              value
            ></el-option>
            <el-option
              v-for="(item,index) in maintainPatrolToDo"
              :key="index"
              :label="item.patrolStandardName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 备注 -->
        <el-form-item :label="$t('lang.lab_remark')">
          <el-input type="textarea" v-model="formbzs.infos"></el-input>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files">
          <upload-morefile ref="uploading" :accept='accept'  upTypes='1'  :clears='clears' @outputFile="getFilexjbz" @removeFile='removeFilexjbz'></upload-morefile>
        </el-form-item>
        <!-- 完成, 异常 -->
        <el-button
          type="primary"
          class="btn-first"
          @click="finishpatro('formbzs')"
        >{{$t('lang.btn_finishs')}}</el-button>
        <el-button
          class="btn_orange detailbtn"
          @click="unfinishpatro('formbzs')"
        >{{$t('lang.btn_unfinishs')}}</el-button>
        <el-divider></el-divider>
      </el-form>
      <!-- 待评价 -->
      <el-form
        ref="forms"
        v-if="this.form.state === 3 && this.form.userId === this.userDataid"
        :model="forms"
        :rules="rules"
        :label-width="require('@/config/enum').c_w8"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <!-- 满意度  -->
        <el-form-item :label="$t('lang.lab_evaluate')" prop="myshow">
          <el-radio-group v-model="forms.myshow">
            <el-radio
              v-for="(item,index) in myshowlist"
              :label="item.id"
              :key="index"
              :value="item.id"
            >{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 评价 -->
        <el-form-item :label="$t('lang.lab_backgroundtexts')">
          <el-input
            maxlength="200"
            class="input"
            type="textarea"
            v-model="forms.contents"
            :placeholder="$t('lang.lab_please_Input')+$t('lang.lab_backgroundtexts')"
          ></el-input>
        </el-form-item>
        <!-- 上传图片 -->
        <el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="files">
          <upload-morefile ref="uploading" :accept='accept'  upTypes='1'   @outputFile="getFilepj" @removeFile='removeFilepj'></upload-morefile>
        </el-form-item>
        <el-button class="btn-first" type="primary" @click="appraise()">{{$t('lang.btn_appraise')}}</el-button>
      </el-form>
    </el-card>
    <!-- 巡检标准预览 -->
    <el-dialog
      :visible.sync="showpatrol"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="$t('lang.lab_inspectionStandardPreview')"
    >
      <el-scrollbar>
        <el-form
          ref="formpatrol"
          :model="formpatrol"
          :label-width="require('@/config/enum').c_w4"
          :label-suffix="require('@/config/enum').c_colon"
        >
          <el-form-item :label="$t('lang.lab_standardName')">{{this.formpatrol.name}}</el-form-item>
          <el-form-item :label="$t('lang.lab_standardMethod')">{{this.formpatrol.info}}</el-form-item>
          <el-form-item :label="$t('lang.lab_photograph')">
            <viewer :images="this.formpatrol.urls">
              <img v-for="(src,index) in this.formpatrol.urls" :src="src" :key="index" class="img" />
            </viewer>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </el-dialog>
    <!-- 巡检路线弹框 -->
    <el-dialog
      :visible.sync="patrolPointLineshow"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
    >
      <el-scrollbar>
        <el-form
          ref="patrolPointLine"
          :model="patrolPointLine"
          :label-width="require('@/config/enum').c_w4"
          :label-suffix="require('@/config/enum').c_colon"
        >
          <el-form-item :label="$t('lang.lab_standardName')">{{this.patrolPointLine.name}}</el-form-item>
          <el-form-item
            :label="$t('lang.lab_patrol_point_order')"
          >{{this.patrolPointLine.patrolPointLineSeq}}</el-form-item>
          <el-form-item
            :label="$t('lang.lab_patrol_point_group')"
          >{{this.patrolPointLine.patrolPointLinePerson}}</el-form-item>
          <el-form-item :label="$t('lang.lab_patrol_point')">
            <img
              v-for="(src,index) in this.patrolPointLineurls"
              :src="src"
              :key="index"
              class="img"
              @click="imgshowto(src)"
            />
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </el-dialog>
    <!-- 点位弹窗 -->
    <el-dialog
      :visible.sync="imgshow"
      :close-on-click-modal="false"
      center
      top="130px"
      width="750px"
    >
      <div ref="imageTofile">
        <div v-for="(item, index) in sign" :key="index.pointId">
          <el-popover placement="top" trigger="hover" :title="pointName">
            <p class="height_all">{{item.msg}}</p>
            <div style="text-align: right; margin: 0; bottom: 0;">
              <el-button
                type="success"
                size="mini"
                @click="seeQrImg(item.pointId, item.msg)"
              >{{$t('lang.lab_seeQrCodes')}}</el-button>
            </div>
            <div
              :style="'left:' + item.left + ';' + 'top:' + item.top + ';' + 'background-image:url(' + item.ptypecss + ');'"
              class="pointImg"
              slot="reference"
            ></div>
          </el-popover>
          <div :style="'left:' + item.left + ';' + 'top:' + item.top " class="pointSpan">
            <span>{{item.msg}}</span>
          </div>
        </div>
        <img :src="getImgUrl" class="getImg" />
      </div>
    </el-dialog>
    <!-- 二维码 -->
    <el-dialog
      :visible.sync="showQr"
      :close-on-click-modal="false"
      center
      top="130px"
      width="320px"
      height="320px"
      :title="QrTitle"
    >
      <vue-qr :text="qrText + ''" :title="'{id:' + qrShowPointId +  '}'" :size="300"></vue-qr>
    </el-dialog>
    <!-- 巡检点位弹框 -->
    <el-dialog
      :visible.sync="rowPointshow"
      :close-on-click-modal="false"
      :title="$t('lang.lab_Patrol_Preview')"
      center
      top="130px"
      width="600px"
    >
      <el-scrollbar>
        <el-form
          ref="rowPoint"
          :model="rowPoint"
          :label-width="require('@/config/enum').c_w4"
          :label-suffix="require('@/config/enum').c_colon"
        >
          <el-form-item :label="$t('lang.lab_pointName')">{{this.rowPoint.pointName}}</el-form-item>
          <el-form-item :label="$t('lang.lab_Explain')">{{this.patrolPointLine.info}}</el-form-item>
          <el-form-item :label="$t('lang.lab_photograph')">
            <viewer :images="this.rowPoint.urls">
              <img v-for="(src,index) in this.rowPoint.urls" :src="src" :key="index" class="img" />
            </viewer>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:400backgroundDetail
 *@Description:400详情
 *@author:孙斯维
 *@Copyright:格众科技
 *@date:2020-03-17
 */
import uploadmoreFile from '../../../components/upload_morefile.vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      clears: false, // 清空按钮
      accept: '.jpg, .jpeg, .png',
      getImgUrl: '', // 获取的图片URL
      hege: 1,
      rimdetails: {}, // 抽审工单详情
      showQr: false, // 查看二维码的弹框
      QrTitle: '', // 查看二维码弹框的title
      qrText: '', // 查看二维码图片左边的名称
      qrShowPointId: '', // 查看二维码显示的内容
      imgshow: false, // 点位弹框显示
      sign: [], // 获取原来图片添加点位的参数数组
      pageCount: 0, // 总页数
      pageNum: 1, // 页数
      pageSize: 10, // 每页显示数量
      backtitle: '', // 返回题目
      rowPoint: {}, // 巡检路线点位弹框对象
      rowPointshow: false, // 巡检路线点位弹框显示
      patrolPointLineshow: false, // 弹窗巡检路线
      patrolPointLineurls: [], // 巡检线路弹窗图片
      showpatrol: false, // 弹窗巡检标准
      jindu: '', // 进度
      show: false, // 巡检标准是否显示
      showToDo: false, // 巡检标准todo是否显示
      showPL: false, // 巡检路线是否显示
      showDevice: false, // 巡检设备是否显示
      showToDoDevice: false, // 巡检设备todo是否显示
      maintainPatrol: [], // 巡检标准list
      maintainPatrolToDo: [], // 巡检标准todolist
      maintainPatrolPointLineToDo: [], // 巡检路线todolist
      maintainPatrolPointLine: [], // 巡检路线list
      maintainDeviceToDo: [], // 巡检设备todolist
      maintainDevice: [], // 巡检设备list
      ysreadtext: '', // 延时工单延时原因
      sendcontent: '', // 派单备注
      peoplelist: [], // 人员分配list
      images: [], // 图片集合
      id: '', // 详情id
      fileListxjbz: [], // 巡检标准上传
      fileListsb: [], // 巡检设备上传
      fileListfj: [], // 附件上传
      fileList: [], // 图片上传
      fileListdpj: [], // 待评价图片上传
      evaluationslist: this.$i18n.t('lang.NewspaperInfoDetail.evaluationslist'), // 评价等级list
      evaluationlist: this.$i18n.t('lang.NewspaperInfoDetail.evaluationlist'), // 难易等级list
      trialOrderresultslist: this.$i18n.t('lang.trialOrderresultslist'), // 抽审中list
      myshowlist: this.$i18n.t('lang.NewspaperInfoDetail.myshowlist'), // 是否对业主显示list
      typeleval: 1, // 级别接口区分字段
      firstLevellist: [], // 一级分类list
      secondLevellist: [], // 二级分类list
      thirdLevellist: [], // 三级分类list
      tableData: [], // 工单一生list
      fileslist: [], // 保存图片list
      fileslistxjbz: [], // 巡检标准保存图片list
      fileslistsb: [], // 巡检设备保存图片list
      withFileslist: [], // 保存附件list
      fileslistdpj: [], // 保存待评价图片list
      orderlist: [], // 评语list
      patrolPointLine: {}, // 巡检线路弹窗对象
      forms: { myshow: 1 }, // 待评价对象
      formsbs: {
        maintainDeviceToDos: '' // 巡检设备
      }, // 巡检设备对象
      formbzs: {
        maintainPatrolToDos: '' // 巡检标准
      }, // 巡检标准对象
      form: {}, // 查询对象
      formcs: {
        trialOrderresultsid: '1',
        content: '',
        contents: '',
        suggest: '',
        randomMaintainType1: '' // 不合格条线ID
      }, // 抽审对象
      formpatrol: {}, // 弹窗
      detailListId: '',
      detailListNum: '',
      detailListCount: '',
      drawName: '',
      haveChild: 0, // 是否有子工单
      // 评价
      rules: {
        myshow: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_evaluate'),
            trigger: 'change'
          }
        ]
      },
      rulesbs: {
        maintainDeviceToDos: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_inspectionDevice'),
            trigger: 'change'
          }
        ]
      },
      rulebzs: {
        maintainPatrolToDos: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_inspectionStandard'),
            trigger: 'change'
          }
        ]
      },
      rulecs: {
        peopleid: [
          {
            required: true,
            message:
              this.$i18n.t('lang.lab_please_Select') +
              this.$i18n.t('lang.lab_Handler'),
            trigger: 'change'
          }
        ]
      }
    }
  },
  props: ['showpages'],
  components: {
		'upload-morefile': uploadmoreFile
	},
  computed: {
    ...mapGetters({
       gardenId: 'gardenId',
       userDataid: 'staffId',
       isClose: 'isClose',
       isDispatch: 'isDispatch' 
      })
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.haveChild = this.$route.query.haveChild
      // 工单的一生
      this.maintainLife()
      // 通过id查询详情
      this.maintains()
      this.maintainPatrols()
      this.maintainPatrolPointLines()
      this.maintainDevsices()
    }
    if (this.$route.query.rimId) {
      // 抽审工单详情
      this.randomInspectionMaintainDetails(this.$route.query.rimId)
    }
    if (this.$route.query.hege) {
      this.hege = this.$route.query.hege
      if (this.$route.query.hege == 1) {
        this.hege = 2
      }
    }
    this.detailListId = this.$route.query.detailListId
    this.detailListNum = this.$route.query.detailListNum
    this.detailListCount = this.$route.query.detailListCount
    this.drawName =this.$route.query.drawName
    // 获取报事分类list
    this.maintainTypes()
  },
  methods: {
    // 获取组件值
    getFile(e) {
         this.fileList.push({
        name: '',
        url: e
    })
    },
    // 移除图片
    removeFile(e) {
    let list1 = []
     for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].url === e) {

        } else {
          list1.push(this.fileList[i])
        }
     }
      this.fileList = list1
    },
    // 附件获取组件值
    getFilefj(e) {
     this.fileListfj.push({
        name: '',
        url: e
    })
    },
    // 移除附件
    removeFilefj(e) {
    let list2 = []
     for (let i = 0; i < this.fileListfj.length; i++) {
        if (this.fileListfj[i].url === e) {

        } else {
          list2.push(this.fileListfj[i])
        }
     }
      this.fileListfj = list2
    },
    // 评价上传图片获取组件值
    getFilepj(e) {
     this.fileListdpj.push({
        name: '',
        url: e
    })
    },
    // 移除评价上传图片
    removeFilepj(e) {
    let list3 = []
     for (let i = 0; i < this.fileListdpj.length; i++) {
        if (this.fileListdpj[i].url === e) {

        } else {
          list3.push(this.fileListdpj[i])
        }
     }
      this.fileListdpj = list3
    },
    // 设备上传图片
    getFilesb(e) {
     this.fileListsb.push({
        name: '',
        url: e
    })
    },
    // 移除设备上传图片
    removeFilesb(e) {
    let list10 = []
     for (let i = 0; i < this.fileListsb.length; i++) {
        if (this.fileListsb[i].url === e) {

        } else {
          list10.push(this.fileListsb[i])
        }
     }
      this.fileListsb = list10
    },
    // 巡检标准上传图片
    getFilexjbz(e) {
     this.fileListxjbz.push({
        name: '',
        url: e
    })
    },
    // 移除巡检标准上传图片
    removeFilexjbz(e) {
    let list11 = []
     for (let i = 0; i < this.fileListxjbz.length; i++) {
        if (this.fileListxjbz[i].url === e) {

        } else {
          list11.push(this.fileListxjbz[i])
        }
     }
      this.fileListxjbz = list11
    },
    // 评价保存
    appraise() {
      // 待评价上传图片
      if (this.fileListdpj.length > 0) {
        for (let i = 0; i < this.fileListdpj.length; i++) {
          this.fileslistdpj.push(this.fileListdpj[i].url)
        }
      }

      let params = {
        id: this.id,
        evaluation: this.forms.contents,
        files: this.fileslistdpj.toString(),
        evaluate: this.forms.myshow
      }
      let loading = this.$loading()
      this.$patch(`/maintains/${this.id}/evaluate`, params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success(this.$i18n.t('lang.lab_comment_successful'))
            this.maintains()
            this.maintainLife()
            this.getEvaluationDetailByGrade()
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 处理完成处理意见
    updateRandomInspection() {
      if (this.hege === 3 && !this.formcs.randomMaintainType1) {
        this.$message.error('请选择不合格条线')
        return
      }
      // 上传图片
      if (this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          this.fileslist.push(this.fileList[i].url)
        }
      }
      let params = {
        Id: this.$route.query.rimId,
        State: this.hege,
        files: this.fileslist.toString(),
        Content: this.formcs.content,
        MaintainId: this.$route.query.id,
        Suggest: this.formcs.suggest
      }
      if (this.hege === 3) {
          params.randomMaintainType1 = this.formcs.randomMaintainType1
      }
      let loading = this.$loading()
      this.$patch(`/randomInspections/update`, params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.$message.success(this.$i18n.t('lang.lab_trialOrderfinsh'))
             var index = this.$keepAlive.indexOf('/manage/trialDetailList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
            this.$router.push({ name: 'trialDetailList', query: { detailListId: this.detailListId, detailListNum: this.detailListNum,drawName:this.drawName, detailListCount: this.detailListCount } })
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 查看二维码
    seeQrImg(pointId, msg) {
      this.QrTitle = this.$i18n.t('lang.lab_seeQrCodes')
      this.qrText = msg
      this.qrShowPointId = pointId
      this.showQr = true
    },
    // 点位图
    imgshowto(urls) {
      this.getImgUrl = urls
      // 存储图片的宽高
      var img = new Image()
      img.src = this.getImgUrl
      this.left = img.width
      this.top = img.height
      this.imgshow = true
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNum = val
      this.maintainPatrols()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.maintainPatrols()
    },
    // 巡检线路
    updatePatrolPointId(row) {
      this.rowPoint = row
      this.rowPointshow = true
    },
    // 巡检线路弹框显示
    updatePatrolPointLineId(id) {
      let loading = this.$loading()
      this.$get(`/patrolPointLineById/${id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.patrolPointLine = res.patrolPointLine
            if (
              res.patrolPointLine.planarGraphId &&
              res.patrolPointLine.planarGraphId != null
            ) {
              this.planarGraphById(res.patrolPointLine.planarGraphId)
              this.getPointList(
                this.patrolPointLine.gardenId,
                this.patrolPointLine.planarGraphId,
                this.patrolPointLine.patrolTypeId
              )
            } else {
              this.patrolPointLineshow = true
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 巡检路线通过id查询图片
    planarGraphById(id) {
      let loading = this.$loading()
      this.$get(`/planarGraphById/${id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.patrolPointLineurls = res.urls
            this.patrolPointLineshow = true
          } else {
            this.patrolPointLineshow = false
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 平面图点位
    getPointList(gardenId, planarGraphId, patrolTypeId) {
      let loading = this.$loading()
      this.$get(
        `/patrolPointList?GardenId=${gardenId}&PlanarGraphId=${planarGraphId}&PatrolTypeId=${patrolTypeId}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.sign = res.pointJsonArray
            if (this.sign.length > 0) {
              for (let i = 0; i < this.sign.length; i++) {
                if (this.sign[i].ptypecss === '/images/patrol/pink.png') {
                  this.sign[i].ptypecss = require('../../../../images/patrol/pink.png')
                } else if (
                  this.sign[i].ptypecss === '/images/patrol/blue.png'
                ) {
                  this.sign[i].ptypecss = require('../../../../images/patrol/blue.png')
                } else if (
                  this.sign[i].ptypecss === '/images/patrol/green.png'
                ) {
                  this.sign[i].ptypecss = require('../../../../images/patrol/green.png')
                } else if (
                  this.sign[i].ptypecss === '/images/patrol/yellow.png'
                ) {
                  this.sign[i].ptypecss = require('../../../../images/patrol/yellow.png')
                } else if (this.sign[i].ptypecss === '/images/patrol/red.png') {
                  this.sign[i].ptypecss = require('../../../../images/patrol/red.png')
                }
              }
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 巡检标准预览弹窗
    patrol(patrolStandard) {
      let loading = this.$loading()
      this.$get(`/patrolStandardById/${patrolStandard}`).then(
        res => {
          loading.close()
          if (res) {
            this.formpatrol = res
            this.showpatrol = true
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 巡检标准完成
    finishpatro(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 上传图片
          if (this.fileListxjbz.length > 0) {
            for (let i = 0; i < this.fileListxjbz.length; i++) {
              this.fileslistxjbz.push(this.fileListxjbz[i].url)
            }
          }
          let params = {
            info: this.formbzs.infos,
            files: this.fileslistxjbz.toString(),
            state: 1
          }
          let loading = this.$loading()
          this.$patch(
            `/maintainPatrol/${this.formbzs.maintainPatrolToDos}`,
            params
          ).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_paperefinsh'))
                this.formbzs.maintainPatrolToDos = ''
                this.maintains()
                this.maintainLife()
                this.maintainPatrols()
                this.maintainPatrolPointLines()
                this.maintainDevsices()
                this.cleanPatrols()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
    // 巡检标准异常
    unfinishpatro(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 上传图片
          if (this.fileListxjbz.length > 0) {
            for (let i = 0; i < this.fileListxjbz.length; i++) {
              this.fileslistxjbz.push(this.fileListxjbz[i].url)
            }
          }

          let params = {
            info: this.formbzs.infos,
            files: this.fileslistxjbz.toString(),
            state: 2
          }
          let loading = this.$loading()
          this.$patch(
            `/maintainPatrol/${this.formbzs.maintainPatrolToDos}`,
            params
          ).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_paperefinsh'))
                this.formbzs.maintainPatrolToDos = ''
                this.maintains()
                this.maintainLife()
                this.maintainPatrols()
                this.maintainPatrolPointLines()
                this.maintainDevsices()
                this.cleanPatrols()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
    // 清空巡检设备信息
    cleandevide() {
      this.formsbs.maintainDeviceToDos = ''
      this.formsbs.infodevs = ''
      this.fileListsb = []
      this.fileslistsb = []
      setTimeout(() => {
        this.$refs.formsbs.clearValidate()
      }, 0)
    },
    // 完成巡检设备
    finishdevide(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 上传图片
          if (this.fileListsb.length > 0) {
            for (let i = 0; i < this.fileListsb.length; i++) {
              this.fileslistsb.push(this.fileListsb[i].url)
            }
          }

          let params = {
            info: this.formsbs.infodevs,
            files: this.fileslistsb.toString(),
            state: 1
          }
          let loading = this.$loading()
          this.$patch(
            `/maintainDevice/${this.formsbs.maintainDeviceToDos}`,
            params
          ).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_paperefinsh'))
                this.maintains()
                this.maintainLife()
                this.maintainPatrols()
                this.maintainPatrolPointLines()
                this.maintainDevsices()
                this.cleandevide()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
    // 异常巡检设备
    unfinishdevide(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 上传图片
          if (this.fileListsb.length > 0) {
            for (let i = 0; i < this.fileListsb.length; i++) {
              this.fileslistsb.push(this.fileListsb[i].url)
            }
          }
          let params = {
            info: this.formsbs.infodevs,
            files: this.fileslistsb.toString(),
            state: 2
          }
          let loading = this.$loading()
          this.$patch(
            `/maintainDevice/${this.formsbs.maintainDeviceToDos}`,
            params
          ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$confirm(
                this.$i18n.t('lang.lab_islist'),
                this.$i18n.t('lang.lab_prompt'),
                {
                  confirmButtonText: this.$i18n.t('lang.btn_confirm'),
                  cancelButtonText: this.$i18n.t('lang.btn_cancel'),
                  type: 'warning'
                }
              )
                .then(() => {
                  // 跳转报事页面
                  this.$router.push({ name: 'repoInfoBackgroundSupply', query: { parentId: this.id } })
                })
                .catch(() => {
                  this.$message.success(this.$i18n.t('lang.lab_paperefinsh'))
                  this.maintains()
                  this.maintainLife()
                  this.maintainPatrols()
                  this.maintainPatrolPointLines()
                  this.maintainDevsices()
                  this.cleandevide()
                })
            }
          })
        }
      })
    },
    // 清空巡检标准信息
    cleanPatrols() {
      this.formbzs.maintainPatrolToDos = ''
      this.formbzs.infos = ''
      this.fileListxjbz = []
      this.fileslistxjbz = []
      setTimeout(() => {
        this.$refs.formbzs.clearValidate()
      }, 0)
    },
    // 巡检标准
    maintainPatrols() {
      let loading = this.$loading()
      this.$get(
        `/maintainPatrol?maintainId=${this.id}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            // 巡检标准完成进度
            this.pageCount = res.pageCount
            this.maintainPatrol = res.maintainPatrol
            if (this.maintainPatrol.length > 0) {
              this.show = true
            } else {
              this.show = false
            }
            // 巡检标准下拉
            this.maintainPatrolToDo = res.maintainPatrolToDo
            if (this.maintainPatrolToDo.length > 0) {
              this.showToDo = true
            } else {
              this.showToDo = false
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 巡检线路完成进度
    maintainPatrolPointLines() {
      let loading = this.$loading()
      this.$get(`/maintainPatrolPointLine?maintainId=${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.maintainPatrolPointLine = res.maintainPatrolPointLine
            if (this.maintainPatrolPointLine.length > 0) {
              this.showPL = true
              var mppl = this.maintainPatrolPointLine
              var fenzi = 0
              for (var int = 0; int < mppl.length; int++) {
                if (mppl[int].state != 0) {
                  fenzi++
                }
              }
              this.jindu = fenzi + '/' + mppl.length
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 巡检设备完成进度
    maintainDevsices() {
      let loading = this.$loading()
      this.$get(`/maintainDevice?maintainId=${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.maintainDeviceToDo = res.maintainDeviceToDo
            this.maintainDevice = res.maintainDevice
            if (this.maintainDevice.length > 0) {
              this.showDevice = true
            } else {
              this.showDevice = false
            }
            if (this.maintainDeviceToDo.length > 0) {
              this.showToDoDevice = true
            } else {
              this.showToDoDevice = false
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 待处理工单保存
    finish(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 上传图片
          if (this.fileList.length > 0) {
            for (let i = 0; i < this.fileList.length; i++) {
              this.fileslist.push(this.fileList[i].url)
            }
          }
          // 上传附件
          if (this.fileListfj.length > 0) {
            for (let j = 0; j < this.fileListfj.length; j++) {
              this.withFileslist.push(this.fileListfj[j].url)
            }
          }
          let params = {
            id: this.id,
            staffid: this.form.staffId,
            source: 1,
            type: 3,
            evaluate: this.form.evaluate,
            files: this.fileslist.toString(),
            content: this.formcs.contents,
            withFiles: this.withFileslist.toString()
          }
          let loading = this.$loading()
          this.$patch(`/maintains/${this.id}/worker`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.btn_finish'))
                this.maintains()
                this.maintainLife()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
    // 隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 抽审工单详情
    randomInspectionMaintainDetails(rimId) {
      let loading = this.$loading()
      this.$get(`/randomInspectionMaintainDetails/${rimId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.rimdetails = res
            this.formcs.content = res.content
            this.formcs.suggest = res.suggest
            this.formcs.randomMaintainType1 = res.randomMaintainType1 && res.randomMaintainType1 !== 0 ? res.randomMaintainType1 : ''
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 查询工单详情
    maintains() {
      let loading = this.$loading()
      this.$get(`/maintains/${this.id}`).then(
        res => {
          loading.close()
          if (res) {
            this.form = res
            if (this.form.garden.id) {
              this.staffs(this.form.garden.id)
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 查询工单一生
    maintainLife() {
      let loading = this.$loading()
      this.$get(`/maintainLife/${this.id}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            if (res.list.length > 0) {
              this.tableData = res.list
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 报事服务分类list
    maintainTypes() {
      this.$get(
        `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=1&parentId=${this.gardenId}`
      ).then(
        res => {
          if (res && res.errCode === 0) {
            if (this.typeleval === 1) {
              this.firstLevellist = res.list
            }
          }
        },
        error => {
          this.$message.error(error)
        }
      )
    },
    // 处理人员下拉
    staffs(gardenIds) {
      let loading = this.$loading()
      this.$get(`/staffs?pageSize=999&pageNo=1&gardenId=${gardenIds}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.peoplelist = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 打印工单
    print() {
      let routeData = this.$router.resolve({ name: 'print400List' })
      localStorage.setItem('form', JSON.stringify(this.form))
      window.open(routeData.href, '_blank')
    },
    // 跳转子工单
    viewChildWorkOrder() {
      sessionStorage.setItem('haveChildParentId', this.id)
        this.$router.push({
          name: 'projectWideRepoInfoList',
          query: {
              trialDetailList: true
            }
        })
    }
  }
}
</script>

<style lang="scss">
.trialDetailDetail .matop {
  margin-top: 30px;
}
.trialDetailDetail .btn_orange {
  background: #f07157;
  color: #ffffff;
}
.trialDetailDetail .el-col-12 {
  // height: 40px;
}
.trialDetailDetail .el-col-6 {
  height: 40px;
}
.trialDetailDetail .el-col-8 {
  height: 40px;
}
.trialDetailDetail .el-col-24 {
  height: 40px;
}
.trialDetailDetail .wid80 {
  width: 80%;
}
.trialDetailDetail .img {
  width: 40px;
  height: 24px;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 5px;
  margin-right: 20px;
}
.trialDetailDetail .btnmar {
  margin-right: 20px;
}
.trialDetailDetail .el-table th {
  padding: 0px;
}
.trialDetailDetail .mat-22 {
  margin-top: 22px;
}
.trialDetailDetail .custom .el-select .el-input__inner {
  width: 400px;
}
.trialDetailDetail .normals {
  font-style: normal;
}
.trialDetailDetail .pad-lef20 {
  padding-left: 20px;
}
.trialDetailDetail .positionPoint {
  position: absolute;
}
.trialDetailDetail .height_all {
  height: 100px;
}
.trialDetailDetail .pointSpan {
  position: absolute;
  color: #f00;
  width: 150px;
  height: 50px;
  span {
    font-weight: 900;
    font-size: 150%;
    color: #f00;
  }
}
.trialDetailDetail .getImg {
  width: 700px;
  height: auto;
}
.trialDetailDetail .pointImg {
  position: absolute;
  margin-left: -25px;
  margin-top: -40px;
  width: 40px;
  height: 50px;
  display: block;
}
.trialDetailDetail .input {
  width: 60vw !important;
}
.el-tooltip__popper.is-light {
  max-width: 300px;
}
.trialDetailDetail .replyCon {
  width: 400px;
}
.trialDetailDetail .sampling {
  padding-left: 20px;
  padding-bottom: 20px;
  color: #606266;
}
</style>